export const MdlaDomain: Readonly<string> = 'SHSDigiCare';

export enum ServiceName {
    RequestService = 'SHSDigiCare.RequestService',
    ClwService = 'SHSDigiCare.ContractLifecycleService',
    OmEmeaRequestService = 'SHSDigiCare.OmEmeaRequestService',
    IroNamService = 'SHSDigiCare.IroNamService',
    UserService = 'SHSDigiCare.UserService',
    CommentService = 'SHSDigiCare.CommentService'
}
